import React from 'react'
import Bloque from '../layout/bloque'
import Column from '../layout/column'
import styled from 'styled-components'
import Buttons from '../botones/multicanalidad'

export default ({ title, multicanalidad }) => {
  return (
    <Bloque>
      <Column
        division={{ mobile: 1, desktop: 2 }}
        order={{ mobile: 2, tablet: 1 }}
      >
        <TitleContainer>
          <div>
            <Title>{title}</Title>
            <Buttons multicanalidad={multicanalidad} />
          </div>
        </TitleContainer>
      </Column>
      <Column
        division={{ mobile: 1, desktop: 2 }}
        order={{ mobile: 1, tablet: 2 }}
      >
        <img
          src="/images/iconos/canales-de-contacto.svg"
          alt="Ahora vos podés decidir como solicitar tu tarjeta"
        />
      </Column>
    </Bloque>
  )
}

const TitleContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const Title = styled.h1`
  color: ${props => props.theme.colors.rojoBac};
  margin-top: 0;
`
